import React from "react";
import { motion } from "framer-motion";
import { FaExternalLinkAlt } from "react-icons/fa";

const AchievementCard = ({ data, index, inView }) => {
  return (
    <motion.div
      className="AchievementCard"
      initial={{ x: index % 2 === 0 ? -100 : 100, opacity: 0 }} // Left for odd, Right for even
      animate={inView ? { x: 0, opacity: 1 } : {}}
      transition={{ duration: 0.6, ease: "easeOut" }}
      whileHover={{ scale: 1.05, transition: { duration: 0.3 } }}>
      <div className="textContainer">
        <div className="header">
          <span className="title">{data.title}</span>
        </div>
        {data.link && (
          <motion.a
          className="date"
            href={data.link}
            target="_blank"
            whileHover={{ scale: 1.2 }}
            whileTap={{ scale: 0.9 }}
            transition={{ type: "spring", stiffness: 300 }}>
            <FaExternalLinkAlt className="linkIcon" />
          </motion.a>
        )}
        {/* <span className="date">{data.date}</span> */}
        {/* <div className="details">{data.details}</div> */}
      </div>
    </motion.div>
  );
};

export default AchievementCard;
